import React, { useState, useEffect } from 'react';

const Download = () => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { ucitajFajlove(); }, []);

    const ucitajFajlove = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://ecopell.ledscreen.rs/core/list-pdfs/');
            const result = await response.json();
            setFiles(result.files || []);
        } catch (err) { console.error("Greška:", err); }
        finally { setLoading(false); }
    };

    const handleDownload = async (filename) => {
        try {
            const response = await fetch(`https://ecopell.ledscreen.rs/core/download-pdf/?file=${filename}`);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (err) { alert("Greška: " + err.message); }
    };

    // NOVA FUNKCIJA ZA SKIDANJE SVIH FAJLOVA
    const skiniSve = async () => {
        if (files.length === 0) return;
        if (!window.confirm(`Da li želite da skinete svih ${files.length} fajlova?`)) return;
        
        for (const f of files) {
            await handleDownload(f.name);
            // Mala pauza između downloada da browser ne blokira requestove
            await new Promise(resolve => setTimeout(resolve, 500));
        }
    };

    const obrisiFajl = async (filename) => {
        if (!window.confirm(`Obriši ${filename}?`)) return;
        try {
            await fetch('https://ecopell.ledscreen.rs/core/delete-pdf/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ file: filename })
            });
            ucitajFajlove();
        } catch (err) { alert("Greška pri brisanju."); }
    };

    const obrisiSve = async () => {
        if (!window.confirm("DA LI STE SIGURNI? Ovo briše SVE PDF fajlove sa servera!")) return;
        try {
            await fetch('https://ecopell.ledscreen.rs/core/delete-all-pdfs/', { method: 'POST' });
            ucitajFajlove();
        } catch (err) { alert("Greška pri masovnom brisanju."); }
    };

    const thStyle = { padding: '12px', borderBottom: '2px solid #1a2a4a', textAlign: 'left', color: '#3366ff', backgroundColor: '#162447' };
    const tdStyle = { padding: '12px', borderBottom: '1px solid #1a2a4a' };

    if (loading) return <div style={{padding: '30px', color: 'white'}}>Učitavanje...</div>;

    return (
        <div style={{ padding: '30px', color: 'white' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', borderBottom: '2px solid #ffcc00', paddingBottom: '10px' }}>
                <h2 style={{ margin: 0 }}><i className="fas fa-file-pdf"></i> Lista PDF Računa</h2>
                <div style={{ display: 'flex', gap: '10px' }}>
                    <button onClick={ucitajFajlove} style={{ backgroundColor: '#1a2a4a', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer' }}>Osveži</button>
                    
                    {/* NOVO DUGME */}
                    <button onClick={skiniSve} style={{ backgroundColor: '#28a745', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>SKINI SVE PDF</button>
                    
                    <button onClick={obrisiSve} style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>OBRIŠI SVE</button>
                </div>
            </div>

            <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b' }}>
                <thead>
                    <tr>
                        <th style={thStyle}>Naziv fajla</th>
                        <th style={thStyle}>Veličina</th>
                        <th style={thStyle}>Kreiran</th>
                        <th style={thStyle}>Akcije</th>
                    </tr>
                </thead>
                <tbody>
                    {files.map((f, i) => (
                        <tr key={i}>
                            <td style={tdStyle}>{f.name}</td>
                            <td style={tdStyle}>{f.size} KB</td>
                            <td style={tdStyle}>{f.created}</td>
                            <td style={tdStyle}>
                                <div style={{display:'flex', gap:'10px'}}>
                                    <button onClick={() => handleDownload(f.name)} style={{ backgroundColor: '#28a745', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}>Download</button>
                                    <button onClick={() => obrisiFajl(f.name)} style={{ backgroundColor: '#444', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer' }}>Obriši</button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Download;